import Layout from "@/components/Layout";
import PageHead from "@/components/PageHead";
import ReportForm from "@/components/ReportForm";

// "How do I report a MOTUS bug" is a question answer engines already answer
// about this site, so the page states the answer in text and in FAQPage
// markup. The wording matches howToReportAnswer() in
// artifacts/api-server/src/public-pages/content.ts, which serves /faq.
const HOW_TO_REPORT_STEPS = [
  "Contact FMCSA first, because only FMCSA can fix your record or your filing.",
  "Then report the bug here so other carriers can see it. You don't need an account.",
  "Describe what you were doing and copy any error message word for word.",
  "DNA staff review every report. Check on yours later at motusbugs.com/my-reports.",
];

const HOW_TO_REPORT_ANSWER = HOW_TO_REPORT_STEPS.join(" ");

export default function ReportPage() {
  return (
    <Layout>
      <PageHead
        title="How to Report a MOTUS Bug"
        description="Report a bug in the FMCSA's MOTUS registration system. Contact FMCSA first, then log the bug here so other carriers can see it. No account needed."
        path="/report"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "How do I report a MOTUS bug?",
              acceptedAnswer: { "@type": "Answer", text: HOW_TO_REPORT_ANSWER },
            },
            {
              "@type": "Question",
              name: "Do I need an account to report a MOTUS bug?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "No. Reporting a MOTUS bug on the MOTUS Bug Board is free and needs no account. You give an email address so DNA staff can reply to you.",
              },
            },
          ],
        }}
      />
      <div className="max-w-2xl mx-auto">
        <ReportForm variant="public" />

        <section className="dna-card mt-8 flex flex-col gap-2" data-testid="section-how-to-report">
          <h2 className="dna-h3">How to report a MOTUS bug</h2>
          <ol className="list-decimal space-y-1.5 pl-5 text-sm leading-relaxed text-[var(--dna-slate-600)]">
            {HOW_TO_REPORT_STEPS.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
          <p className="text-sm text-[var(--dna-slate-600)]">
            Your name, email, phone number and USDOT number are never shown on the public board.
          </p>
          <p className="text-sm text-[var(--dna-slate-600)]">
            {/* Server-rendered pages, so plain anchors, not client routes. */}
            <a href="/issues" className="dna-link font-semibold">
              Check the list of known MOTUS issues
            </a>{" "}
            first, in case yours is already there, or read the{" "}
            <a href="/guides/motus-login-errors" className="dna-link font-semibold">
              MOTUS login errors and fixes
            </a>
            .
          </p>
        </section>
      </div>
    </Layout>
  );
}
